export default () => (
  <div className="whitespace-pre-line">
    <p className="text-xl mb-5 whitespace-pre-line">
      For now, this is a curated collection of quotes and thoughts. 
      <br/>
      I thought it might be fun to leave a psyche-print on a tiny corner of the internet.
      <br />
      As a friend so aptly put it, "the CS major's finsta".
    </p>
    <iframe src="https://giphy.com/embed/Y4VkyhG1RO7pQbQFhF" width="480" height="269" className="max-w-full" frameBorder="0" allowFullScreen></iframe><p><a href="https://giphy.com/gifs/youngthug-hot-young-thug-gunna-Y4VkyhG1RO7pQbQFhF"></a></p>
  </div>
);

